import { getPreviousConversations } from "../../../services/agent.service";
import { PreviousConversationListEntity } from "../model";

export const AGENTIC_CHAT_BOT_ACTIONS = {
  GET_PREVIOUS_CONVERSATIONS: "GET_PREVIOUS_CONVERSATIONS",
  UPDATE_SHOW: "UPDATE_SHOW",
  SET_MESSAGES: "SET_MESSAGES",
};

export const getPreviousConversationsThunk = () => {
  return async (dispatch: any) => {
    const res = await getPreviousConversations();
    const sanitizedRes = new PreviousConversationListEntity(res);

    try {
      dispatch({
        type: AGENTIC_CHAT_BOT_ACTIONS.GET_PREVIOUS_CONVERSATIONS,
        payload: sanitizedRes,
      });
    } catch (error) {}
  };
};

export const updateConvHistoryShowStatusThunk = (val: boolean) => {
  return async (dispatch: any) => {
    try {
      dispatch({
        type: AGENTIC_CHAT_BOT_ACTIONS.UPDATE_SHOW,
        payload: val,
      });
    } catch (err) {}
  };
};
